
<template>
  <div class="TableInput">
    <el-input
      id="input1"
      ref="input"
      size="mini"
      v-model="value1"
      @focus="doFocus"
      @blur="doBlur"
      @input="inputText"
      @keydown.down.native="downkey($event)"
      @keydown.up.prevent.native="upkey($event)"
      @keydown.enter.native="enterkey($event)"
      @dblclick.native="searchInfor"
    ></el-input>
    <el-popover placement="top-start" width="350" trigger="manual" v-model="visible">
      <vxe-table
        border
        highlight-hover-row
        highlight-current-row
        :keyboard-config="{isArrow:true}"
        :auto-resize="true"
        resizable
        size="small"
        ref="xTable"
        height="250"
        :data="tableData"
        show-overflow
        show-header-overflow
        @current-change="currentChangeEvent"
      >
        <template v-for="(item,index) in tableHeadData">
          <vxe-table-column
            :field="item.Key"
            :title="item.Label"
            width="100"
            v-if="item.Key=='FullName'"
            :key="index"
          ></vxe-table-column>
          <vxe-table-column
            :field="item.Key"
            :title="item.Label"
            width="100"
            v-else-if="item.Key=='BaseCode'"
            :key="index"
          ></vxe-table-column>
          <vxe-table-column :field="item.Key" :title="item.Label" width="100" v-else :key="index"></vxe-table-column>
        </template>
      </vxe-table>
    </el-popover>
  </div>
</template>

<script>
// 引入样板数组
import dataConfig from "@/utils/data.js";
// 工具库
import tool from "@/utils/tool";
export default {
  data() {
    return {
      // 值字段
      value1: this.value,
      oldVal1: {},
      tableHeadData: dataConfig.HandlersConfig, //表格表头数据
      tableData: [], //表格数据
      // 状态字段
      visible: false, //是否显示出模糊收索列表
      cursorMove: true, //聚焦是否可以移动
      rowIndex: 0, //行索引
      addShow: false, //新增弹出框是否显示
      searchShow: false, //选择弹出框是否显示
      searchData: {
        // 传入下一个弹出框的字段，包含标题，树状图url，表格url，过滤url
        title: "",
        url1: "",
        url2: "",
        url3: "",
        type: "",
        classify: ""
      }
    };
  },
  props: {
    // 输入框数据
    value: {
      // default: () => {
      //   return { FullName: "", KtypeId: Number("") };
      // },
      type: String
    },
    labelName: [String],
    classify: [String]
  },
  methods: {
    // 选中行改变事件
    currentChangeEvent({ row }) {
    },
    // 按上键
    upkey(e) {
      if (!this.visible) {
        this.$emit("preFocus");
      } else {
        if (this.rowIndex != 0) {
          this.rowIndex--;
        }
        this.$refs.xTable.setCurrentRow(this.tableData[this.rowIndex]);
        this.$refs.xTable.scrollToRow(this.$refs.xTable.getCurrentRow());
      }
    },
    // 按下键
    downkey(e) {
      if (!this.visible) {
        this.$emit("nextFocus");
      } else {
        if (this.tableData && this.rowIndex + 1 < this.tableData.length) {
          this.rowIndex++;
        }
        this.$refs.xTable.setCurrentRow(this.tableData[this.rowIndex]);
        this.$refs.xTable.scrollToRow(this.$refs.xTable.getCurrentRow());
      }
    },
    // 回车回调
    enterkey() {
      // 弹出模糊匹配框的时候回调数据
      if (this.visible) {
        if (this.tableData && this.tableData.length != 0) {
          // this.$emit('enterkey',this.$refs.xTable.getCurrentRow());
          this.chooseBack(this.$refs.xTable.getCurrentRow());
        } else {
          // this.chooseBack(this.oldVal1);
        }
        return;
      }
      // 弹出选择框的时候回调数据
      if (this.searchShow) {
        return;
      }
      // 不是选择框和下拉显示框出现的情况下弹出选择框
      this.searchShow = true;
      this.$refs.input.blur();
    },
    // 输入框输入文字
    inputText(text) {
      if (text == "") {
        // this.value.FullName = this.value.FullName.replace(/^ +| +$/g, "");
        this.visible = false;
      } else {
        this.initListTable(text);
        this.visible = true;
      }
    },
    // 初始化模糊匹配列表数据
    initListTable(Keyword) {
      let params = {
        user_id: tool.getLocal("userid"), //用户ID
        session_id: tool.getLocal("sessionid"), //用户凭证
        Keywords: Keyword, //模糊查询参数
        Classify: "Goods", //分类(Goods,Person,Client,ClientA,ClientB,Area,Department,Stock)
        Stoped: 0
      };
      this.request
        .post("/index/Goods/AllSearch", { jparams: JSON.stringify(params) })
        .then(res => {
          // 接收后端发送回来的数据
          this.tableData = res.data;
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 聚焦触发全输入框内容
    doFocus() {
      event.currentTarget.select();
    },
    // 失去焦点，隐藏选择框
    doBlur() {
      this.visible = false;
      this.rowIndex = 0; //重置索引
      // if (this.value1.FullName == "") {
      //   this.value1 = { FullName: "", KtypeId: Number("") };
      // } else {
      //   this.value1 = { ...this.oldVal1 };
      // }
    }
  },
  watch: {
    // 默认选中表格第一行
    tableData: {
      handler: function(newVal, oldVal) {
        if (newVal && newVal.length > 0) {
          // this.$nextTick(()=>{
          this.$refs.xTable.setCurrentRow(this.tableData[0]);
          // })
        }
      },
      deep: true //对象内部的属性监听，也叫深度监听
    }
  }
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/Input/TableInput/TableInput.vue